import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentActivities = styled.div`
  width: 100%;
  height: fit-content;
`;

export const useStyles = makeStyles(() => ({
  containEvents: {
    margin: "0",
  },
  bodyEvents: {
    backgroundColor: theme.neutral.white,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rowContainEvents: (props) => ({
    width: "100%",
    marginLeft: "0.45rem",
  }),
  colCardEvents: {
    width: "100%",
    height: "fit-content",
    margin: "1em 0",
  },
}));
